module.exports = __webpack_public_path__ + "img/mapa_mina.adf7ce6d.png";